{
    "roleList": {
        "roleName": "Role Name",
        "roleDescription": "Role Description",
        "application": "Application",
        "status": "Status",
        "action": "Action"
    }
}